// context/PersonalizeModalContext.tsx
import React, { createContext, useContext, useState } from 'react'

interface ProductData {
  product: any
  inputs: any
  isEdit?: string
  dedicationImage?: any
  languages?: any
}

interface ContextProps {
  isOpen: boolean
  productData: ProductData | null
  openModal: (data: ProductData) => void
  closeModal: () => void
  updateProductData: (updatedFields: Partial<ProductData['product']>) => void
  updateCoverImage: (image: any) => void
}

const NotebookModalContext = createContext<ContextProps | undefined>(undefined)

export const NotebookModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [productData, setProductData] = useState<ProductData | null>(null)

  const openModal = (data: ProductData) => {
    const normalizedData: ProductData = {
      ...data,
      isEdit: data.isEdit ?? '0',
    }
    setProductData(normalizedData)
    setIsOpen(true)
  }

  const closeModal = () => {
    setProductData(null)
    setIsOpen(false)
  }

  const updateCoverImage = (image: any) => {
    setProductData(prev => prev ? { ...prev, dedicationImage: image } : null)
  }

  const updateProductData = (updatedFields: Partial<ProductData['product']>) => {
    setProductData(prev => {
      if (!prev) return null
      return {
        ...prev,
        product: {
          ...prev.product,
          ...updatedFields,
        },
      }
    })
  }

  return (
    <NotebookModalContext.Provider 
      value={{ isOpen, productData, openModal, closeModal, updateProductData, updateCoverImage }}
    >
      {children}
    </NotebookModalContext.Provider>
  )
}

export const useNotebookModal = () => {
  const context = useContext(NotebookModalContext)
  if (!context) {
    throw new Error('useNotebookModal must be used within NotebookModalProvider')
  }
  return context
}